import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../datasource/api";
import {
  EmailOtpDataType,
  forgotPasswordDispatchType,
} from "../../modals/IforgotPasswordCard";
import { resetPasswordDataType } from "../../modals/IresetPasswordCard";
import routesName from "../../constants/routesName";
import CryptoJS from "crypto-js";
import axios from "axios";

export const emailCheck = createAsyncThunk(
  "emailCheck",
  async (data: forgotPasswordDispatchType, { rejectWithValue }) => {
    try {
      const response = await API.post("Login/forgotpasswordadmincheck", data);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 500) {
        window.location.href = routesName.errorPage;
      }
      return rejectWithValue(error);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "forgotPassword",
  async (data: forgotPasswordDispatchType, { rejectWithValue }) => {
    try {
      const response = await API.post("Login/forgotpassword", data);
      return response.data;
    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "verifyOtp",
  async (data: EmailOtpDataType, { rejectWithValue }) => {
    try {
      const response = await API.post("Login/verifyotp", data);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 500) {
        window.location.href = routesName.errorPage;
      }
      return rejectWithValue(error);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "resetPassword",
  async (data: resetPasswordDataType, { rejectWithValue }) => {
    try {
      console.log(data, 374747)
      const AES_KEY = '2dc41670ehdjurl1jdhu76yhtf6d48bb';
      const AES_IV = '1208987836506021';
      const encryptString = (plainText: string) => {
        const keyUtf8 = CryptoJS.enc.Utf8.parse(AES_KEY || "");
        const ivUtf8 = CryptoJS.enc.Utf8.parse(AES_IV || "");
        const encrypted = CryptoJS.AES.encrypt(plainText, keyUtf8, { iv: ivUtf8 });
        return encrypted.toString();
      };

      const Email = data.email;
      const NewPassword = encryptString(data.password);
      const url = process.env.REACT_APP_MA_RESET_PASSWORD_URL || '';
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('newlogin')} `, // Add token here
      };

      const maResponse = await axios.post(url, { Email, NewPassword }, { headers });

      if (maResponse) {
        // temporarily remove token for this public API
        const headers1 = {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('accessToken')} `, // Add token here
        };


        const response = await API.post("Login/resetpassword",
          data,
          {
            headers: headers1
          }
        );

        return response.data;
      }



    } catch (error: any) {
      // if (error?.response?.status === 500) {
      //   window.location.href = routesName.errorPage;
      // }
      return rejectWithValue(error);
    }
  }
);


// export const resetPassword = createAsyncThunk(
//   "auth/resetPassword",
//   async (data: resetPasswordDataType, { rejectWithValue }) => {
//     try {
//       const { accessToken } = data;

//       const response = await API.post(
//         "Login/resetpassword",
//         { data: data },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}), // ✅ add only if token exists
//           },
//         }
//       );

//       return response.data;
//     } catch (error: any) {
//       if (error?.response?.status === 500) {
//         window.location.href = routesName.errorPage;
//       }
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );